/* eslint-disable jsx-a11y/anchor-is-valid */
import { useRef, useState } from 'react'
import { format } from 'date-fns'
import { useOnClickOutside } from 'src/hooks/useOnClickOutside'
import PublicLessonStatus from './public-lesson-status'

const LessonRow = ({
  item,
  onEdit = () => {},
  onDelete = () => {},
  onPrint = () => {},
  onCopy = () => {},
}) => {
  const refMenu = useRef()
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  useOnClickOutside(refMenu, () => setIsMenuOpen(false))

  const handleMenuOpen = (e) => {
    e.preventDefault()
    setIsMenuOpen(!isMenuOpen)
  }

  const handleEditClick = (e) => {
    e.preventDefault()
    onEdit()
    setIsMenuOpen(false)
  }

  const handleDeleteClick = (e) => {
    e.preventDefault()
    onDelete()
    setIsMenuOpen(false)
  }

  const handlePrintClick = (e) => {
    e.preventDefault()
    onPrint()
    setIsMenuOpen(false)
  }

  const handleCopyClick = (e) => {
    e.preventDefault()
    onCopy()
    setIsMenuOpen(false)
  }

  return (
    <div className="purchaseHb-table__row">
      <div className="purchaseHb-table__col purchaseHb-table__col-1">
        <div className="purchaseHb-table__wrap">
          <div className="checkbox">
            <input type="checkbox" />
            <span className="checkbox-ico" />
          </div>
          <div className="purchaseHb-table__img">
            {item.image ? (
              <img
                src={`${process.env.REACT_APP_S3_HOST}/${item.image}`}
                alt=""
              />
            ) : (
              <img src="/account/img/purchaseHb-2.svg" alt="" />
            )}
          </div>
          <div className="purchaseHb-table__info">
            <a href="#" onClick={onEdit} className="purchaseHb-link">
              {item.title}
            </a>
            <a href="#" className="second-btn">
              {item.subject?.name}
            </a>
          </div>
        </div>
      </div>
      {/* <div className="purchaseHb-table__col purchaseHb-table__col-2">
        <div className="myShop-price">
          <span>List price: </span>
          <b>{Number(item.price) > 0 ? '$' + Number(item.price).toFixed(2) : 'FREE'}</b>
        </div>
        <div className="myShop-price">
          <span>Payout:</span>
          <b>{Number(item.price) > 0 ? '$' + (Number(item.price) * 0.8).toFixed(2) : 'FREE'}</b>
        </div>
      </div> */}
      {/* <div className="purchaseHb-table__col purchaseHb-table__col-3">---</div> */}
      <div className="purchaseHb-table__col purchaseHb-table__col-4">
        <PublicLessonStatus status={item?.status} />
      </div>
      <div className="purchaseHb-table__col purchaseHb-table__col-5">
        {item.created_at && format(new Date(item.created_at), 'MMM d')}
      </div>
      <div className={`dropHb ${isMenuOpen ? 'active' : ''}`}>
        <div onClick={handleMenuOpen} className="dropHb-top">
          <i className="hb-ico dots-ico" />
        </div>
        <div ref={refMenu} className="dropHb-info">
          <ul>
            <li>
              <a href="#" onClick={handleEditClick}>
                <i className="hb-ico edit-ico" />
                Edit
              </a>
            </li>
            <li>
              <a href="#" onClick={handleDeleteClick}>
                <i className="hb-ico trash-ico" />
                Delete
              </a>
            </li>
            <li>
              <a href="#" onClick={handlePrintClick}>
                <i className="hb-ico print-ico" />
                Print
              </a>
            </li>
            <li>
              <a href="#" onClick={handleCopyClick}>
                <i className="hb-ico report-ico" />
                Duplicate
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default LessonRow
